import { useQueryClient } from '@tanstack/react-query';
import { api } from '../../api.js';
import { useAuth } from '../../auth/AuthProvider.js';

export function OrgSwitcher() {
  const { activeOrgId, memberships } = useAuth();
  const qc = useQueryClient();
  if (memberships.length === 0) return null;

  const handleChange = async (orgId: string) => {
    await api('/orgs/switch', {
      method: 'POST',
      body: JSON.stringify({ orgId }),
    });
    await qc.invalidateQueries();
    // Reload to pick up the new active org from a fresh session.
    window.location.reload();
  };

  return (
    <select
      value={activeOrgId ?? ''}
      onChange={(e) => void handleChange(e.target.value)}
      className="rounded border px-2 py-1 text-sm"
    >
      {memberships.map((m) => (
        <option key={m.organization_id} value={m.organization_id}>
          {m.organization_name}
        </option>
      ))}
    </select>
  );
}
